/**
 * personality-style-i18n.ts — Lecture FR/EN d'un style de personnalité (table personality_styles).
 *
 * Module PUR (client + serveur). Cascade langue-courante → autre langue → code brut,
 * comme offer-i18n.ts. Ne lit JAMAIS le champ brut directement dans le JSX.
 */

export type PersonalityStyleRow = {
  id?: string;
  code: string;
  category?: string | null;
  labelFr?: string | null;
  labelEn?: string | null;
  descriptionFr?: string | null;
  descriptionEn?: string | null;
  isSystem?: boolean;
  isActive?: boolean;
  sortOrder?: number;
};

function isFr(language?: string): boolean {
  return (language || "fr").toLowerCase().startsWith("fr");
}

/** Libellé localisé d'un style ; fallback autre langue puis code. */
export function pickStyleLabel(style: PersonalityStyleRow | null | undefined, language?: string): string {
  if (!style) return "";
  const fr = style.labelFr?.trim() || "";
  const en = style.labelEn?.trim() || "";
  return (isFr(language) ? fr || en : en || fr) || style.code || "";
}

/** Description localisée d'un style ; fallback autre langue puis "". */
export function pickStyleDescription(style: PersonalityStyleRow | null | undefined, language?: string): string {
  if (!style) return "";
  const fr = style.descriptionFr?.trim() || "";
  const en = style.descriptionEn?.trim() || "";
  return (isFr(language) ? fr || en : en || fr) || "";
}
